(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-handmade-note"] && !Shopify.designMode) return;
  try {
    // Links to a note inside a closed accordion (e.g. the "Hand-sculpted" chip) open it first.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    const note = id && document.getElementById(id);
    if (!note || !note.classList.contains('custom-handmade-note-wrapper')) return;
    const details = note.closest('details');
    if (details && !details.open) details.open = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const STORAGE_KEY = 'custom-size-guide-unit';

    const readUnit = () => {
      try {
        return localStorage.getItem(STORAGE_KEY);
      } catch {
        return null;
      }
    };

    const saveUnit = (unit) => {
      try {
        localStorage.setItem(STORAGE_KEY, unit);
      } catch {
        /* Storage blocked: the switch still works for this visit. */
      }
    };

    class CustomSizeGuide extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        const saved = readUnit();
        if (saved === 'in' || saved === 'cm') this.setUnit(saved);

        this.dialog.addEventListener('click', this.onClick);
        // Esc and dialog.close() both end here, so the page unlocks however it was closed.
        this.dialog.addEventListener('close', this.onClose);
      }

      disconnectedCallback() {
        this.dialog?.removeEventListener('click', this.onClick);
        this.dialog?.removeEventListener('close', this.onClose);
      }

      // Horizon's own page scroll lock (assets/base.css, html[scroll-lock]).
      onClose = () => {
        document.documentElement.removeAttribute('scroll-lock');
      };

      onClick = (event) => {
        // A click on the dialog element itself (not its content) is a click on the backdrop.
        if (event.target === this.dialog || event.target.closest('[data-custom-size-guide-close]')) {
          this.close();
          return;
        }
        const unitButton = event.target.closest('[data-unit]');
        if (unitButton) {
          this.setUnit(unitButton.dataset.unit);
          saveUnit(unitButton.dataset.unit);
        }
      };

      setUnit(unit) {
        this.querySelectorAll('[data-unit]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
        });
        this.querySelectorAll('[data-unit-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.unitPanel !== unit;
        });
      }

      open() {
        if (!this.dialog || this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.setAttribute('scroll-lock', '');
      }

      close() {
        if (!this.dialog?.open) return;
        this.dialog.close();
      }
    }

    if (!customElements.get('custom-size-guide')) {
      customElements.define('custom-size-guide', CustomSizeGuide);

      // Delegated, so the link survives Horizon re-rendering the variant picker on every size change.
      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-custom-size-guide-open]');
        if (!opener) return;
        const guide = document.getElementById('custom-size-guide');
        if (!guide) return;
        event.preventDefault();
        guide.open();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
